export default {
  cancel: '取消',
  ok: '确定',
}